import { render, staticRenderFns } from "./holecutout.vue?vue&type=template&id=2f35eb32&"
import script from "./../../ts/partcreation/holecutout.ts?vue&type=script&lang=js&"
export * from "./../../ts/partcreation/holecutout.ts?vue&type=script&lang=js&"
import style0 from "./../../assets/css/partcreation/holecutout.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports